module.exports = "<div class=vue-toast-manager_container :class=classesOfPosition> <vue-toast v-for=\"toast in toasts\" :message=toast.message :options=toast.options :destroyed.sync=toast.isDestroyed :position=$index></vue-toast> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/statamic/resources/js/components/toast/manager/template.html
// module id = 801
// module chunks = 2